"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gradeResultType_1 = __importDefault(require("./gradeResultType"));
const IB_EE = {
    UNKNOWN: 'IB/ee/unknown',
    A: 'IB/ee/a',
    B: 'IB/ee/b',
    C: 'IB/ee/c',
    D: 'IB/ee/d',
    E: 'IB/ee/e',
};
const IB_TOK = {
    UNKNOWN: 'IB/tok/unknown',
    A: 'IB/tok/a',
    B: 'IB/tok/b',
    C: 'IB/tok/c',
    D: 'IB/tok/d',
    E: 'IB/tok/e',
};
const IB_CAS = {
    UNKNOWN: 'IB/cas/unknown',
    PASS: 'IB/cas/pass',
    FAIL: 'IB/cas/fail',
};
const IB_RESULTS = {
    UNKNOWN: 'IB/results/unknown',
    DIPLOMA_AWARDED: 'IB/results/diplomaAwarded',
    NOT_AWARDED: 'IB/results/notAwarded',
};
const CIE_AWARDS = {
    NO_AWARDS: 'CIE/awards/noAwards',
    TOP_IN_COUNTRY: 'CIE/awards/topInCountry',
    TOP_IN_WORLD: 'CIE/awards/topInWorld',
};
const NCEA_SUBJECT_ENDORSEMENT = {
    NO_ENDORSEMENT: 'NCEA/subjectEndorsement/noEndorsement',
    MERIT: 'NCEA/subjectEndorsement/merit',
    EXCELLENCE: 'NCEA/subjectEndorsement/excellence',
};
const NZQA_AWARDS = {
    NO_SCHOLARSHIP: 'NZQA/awards/noScholarship',
    SCHOLARSHIP: 'NZQA/awards/scholarship',
    OUTSTANDING: 'NZQA/awards/outstanding',
    TOP_SCHOLAR_OUTSTANDING: 'NZQA/awards/topScholarOutstanding',
};
const NZQA_OVERALL_AWARDS = {
    NO_AWARDS: 'NZQA/overallAwards/noAward',
    SCHOLARSHIP_AWARD: 'NZQA/overallAwards/scholarshipAward',
    OUTSTANDING_SCHOLAR_AWARD: 'NZQA/overallAwards/outstandingScholarAward',
    PREMIER_SCHOLAR_AWARD: 'NZQA/overallAwards/premierScholarAward',
};
const IELTS_TEST_TYPE = {
    ACADEMIC: 'IELTS/academic',
    GENERAL: 'IELTS/general',
};
const GPA_REGIONS = {
    US: 'usa',
    BRAZIL: 'brazil',
    RUSSIA: 'russia',
    JAPAN: 'japan',
};
const GPA_YEARS = {
    FRESHMAN: 'freshman',
    SOPHOMORE: 'sophomore',
    JUNIOR: 'junior',
    SENIOR: 'senior',
};
exports.default = {
    [gradeResultType_1.default.IB_EE_PREDICTED_GRADE]: IB_EE,
    [gradeResultType_1.default.IB_EE_ACHIEVED_GRADE]: IB_EE,
    [gradeResultType_1.default.IB_TOK_PREDICTED_GRADE]: IB_TOK,
    [gradeResultType_1.default.IB_TOK_ACHIEVED_GRADE]: IB_TOK,
    [gradeResultType_1.default.IB_CAS_PREDICTED_GRADE]: IB_CAS,
    [gradeResultType_1.default.IB_CAS_ACHIEVED_GRADE]: IB_CAS,
    [gradeResultType_1.default.IB_RESULTS]: IB_RESULTS,
    [gradeResultType_1.default.CIE_AWARDS]: CIE_AWARDS,
    [gradeResultType_1.default.NCEA_SUBJECT_ENDORSEMENT]: NCEA_SUBJECT_ENDORSEMENT,
    [gradeResultType_1.default.NCEA_LEVEL_1_ENDORSEMENT]: NCEA_SUBJECT_ENDORSEMENT,
    [gradeResultType_1.default.NCEA_LEVEL_2_ENDORSEMENT]: NCEA_SUBJECT_ENDORSEMENT,
    [gradeResultType_1.default.NCEA_LEVEL_3_ENDORSEMENT]: NCEA_SUBJECT_ENDORSEMENT,
    [gradeResultType_1.default.NZQA_AWARDS]: NZQA_AWARDS,
    [gradeResultType_1.default.NZQA_OVERALL_AWARDS]: NZQA_OVERALL_AWARDS,
    [gradeResultType_1.default.IELTS_TEST_TYPE]: IELTS_TEST_TYPE,
    [gradeResultType_1.default.GPA_REGION]: GPA_REGIONS,
    [gradeResultType_1.default.GPA_YEAR]: GPA_YEARS,
};
//# sourceMappingURL=gradeResultValueType.js.map